<template>
	<div class="background">
		<div class="container">

			<div class="alerts-panel">
				<alert v-for="alert in alerts" 
					:key="alert.timestamp+alert.message" 
					:classes="alert.class"
					:visible="alert.visible"
					:errors="alert.errors"
					:icon="alert.icon"
					:message="alert.message"
					:self-clear="alert.selfClear"
					v-on:close="closeAlert(alert.timestamp)">
				</alert>

				<a v-if="alerts.length > 1" href="#" v-on:click.prevent="clearAlerts">Clear All Alerts</a>
			</div>

			<form v-on:submit.prevent="authenticate" class="login-form">
				<div>
					<img :src="logoSrc">
				</div>

				<h1>SIGN IN</h1>

				<input type="email" 
					name="email" 
					placeholder="Email" 
					class="form-control" 
					v-model="payload.email" 
					style="margin-bottom: -1px;">

				<input v-if="'partnerAccess' in $route.params && $route.params.partnerAccess == 'partner-access'" 
					type="email" 
					name="channel_partner_email" 
					class="form-control" 
					v-model="payload.channel_partner_email"
					placeholder="Channel Partner Email" 
					style="margin-bottom: -1px;">

				<input type="password" name="password" placeholder="Password" class="form-control" v-model="payload.password">

				<div>
					<label>
						<input type="checkbox" v-model="staySignedIn">
						Stay signed in on this device
					</label>
				</div>

				<alert	
					:message="alert.message" 
					:icon="alert.icon" 
					:visible="alert.visible"
					:classes="alert.class"
					v-on:close="alert.visible = false">	
				</alert>

				<button type="submit" class="btn btn-primary">
					<i class="fa fa-sign-in-alt"></i>
					Login
				</button>

				<p class="forgot-password"><a href="#" v-on:click.prevent="passwordResetRequest">I forgot my password</a></p>
			</form>
			
			<modal-dialog
				title="Password Reset Request" 
				:modal-visible="resetRequest.visible" 
				confirm-button-text="Submit"
				:submit-visible="resetRequest.submitVisible"
				:cancel-button-text="resetRequest.cancelButtonText"
				v-on:confirm="submitResetRequest"
				v-on:closeModal="resetRequest.visible = false">

				<div v-if="!resetAlert.visible">

					<p>Enter your email and a password reset link will be sent to you.</p>
					
					<field label="Your Email" col-class="col-md-4"
						:params="{type:'email',required:true}"
						v-model="resetRequest.email">
					</field>

					<field label="Notification type" col-class="col-md-4"
						:params="{type:'boolean',doubleLabels:['Email','SMS']}"
						v-model="resetRequest.smsNotification">
					</field>
				</div>

				<div class="alert"
					v-if="resetAlert.visible"
					:class="resetAlert.class">
					{{resetAlert.msg}}
				</div>

			</modal-dialog>
		</div>
	</div>
</template>

<script>
import Alert from "@/components/Alert"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"

import AppStartup from "@/mixins/AppStartup.js"

export default {

	name: 'Login',
	components: {
		Alert,
		Field,
		ModalDialog
	},
	mixins: [AppStartup],
	data() {
		return {
			payload: {
				email: "",
				password: ""
			},
			alert: {
				class: "alert-warning",
				message: "Logging in...",
				icon: "fa-spinner fa-spin",
				visible: false
			},
			staySignedIn: true,
			resetRequest : {
				visible: false,
				email: "",
				smsNotification: false, 
				submitVisible: true,
				cancelButtonText: "Cancel"
			},
			resetAlert: {
				msg: "",
				visible: false,
				class: ""
			},
			alerts: []
		}
	},
	computed: {
		logoSrc() {
			return window.apiRoot+"resources/logo-800.png?v=2021-11-26"
		}
	},
	methods: {
		authenticate() {
			let vm = this

			this.alert.visible = true
			this.alert.message = "Logging in...";
			this.alert.icon = "fa-spinner fa-spin";
			this.alert.class = "alert-info"

			this.postData("user/authenticate", this.payload).then(function(response){

				if (response.success == true) {
					vm.alert.visible = true
					vm.alert.message = "Success! Redirecting...";
					vm.alert.icon = "fa-check";
					vm.alert.class = "alert-success"

					localStorage.apiKey = response.data.api_key

					localStorage.sessionToken = JSON.stringify(response.data.session_token)

					//if stay signed in was checked, record this to localStorage
					if (vm.staySignedIn) 
						localStorage.staySignedIn = true

					if ("activateAccountSetupMode" in response.data)
						vm.$store.accountSetupMode = response.data.activateAccountSetupMode
					if ("activateCompanySetupMode" in response.data)
						vm.$store.companySetupMode = response.data.activateCompanySetupMode

					vm.$bus.$emit("updateUserPermissions",response.data)
					vm.$bus.$emit("loginStatus",true)
					vm.$bus.$emit("messagePollRequest")

					vm.showNotificationPrompt()
					vm.registerOneSignalId()

					if (vm.$store.companySetupMode)
						vm.$router.push("/setup")
					else if ("partnerAccess" in vm.$route.params && vm.$route.params.partnerAccess == 'partner-access')
						vm.$router.push("/")
				}
				else {
					vm.alert.visible = true
					vm.alert.icon = "fa-times";
					vm.alert.class = "alert-danger"
					if ("errors" in response && response.errors.length > 0 && response.errors[0] != "Request failed") {
						vm.alert.message = response.errors[0]
					}
					else 
						vm.alert.message = "Incorrect credentials";
				}
			})
		},
		passwordResetRequest() {
			this.resetRequest.visible = true
			this.resetAlert.visible = false;
			this.resetRequest.cancelButtonText = "Cancel"
			this.resetRequest.submitVisible = true
			this.$nextTick(() => this.$refs.emailReset.focus())
			//this.$refs.emailReset.$el.focus()
		},
		submitResetRequest() {
			let vm = this
			let payload = {
				email: this.resetRequest.email,
				smsNotification: this.resetRequest.smsNotification
			}
			this.postData("user/reset-request",payload).then(function(response){
				vm.resetAlert.visible = true;

				if (vm.resetRequest.smsNotification)
					vm.resetAlert.msg = "Please check your mobile phone SMS messages for password reset instructions"
				else
					vm.resetAlert.msg = "Please check your email for password reset instructions"
				
				vm.resetAlert.class = "alert-success"

				vm.resetRequest.cancelButtonText = "Done"
				vm.resetRequest.submitVisible = false

				vm.resetRequest.email = ""
			})
		}

	},
	created() {
		this.spinner(false)

		this.$bus.$on("pushAlert",this.onPushAlert)
	}

}
</script>

<style scoped>
	form.login-form {
		text-align: center;
		max-width: 500px;
		margin: auto;
		margin-top: 20px;
		margin-bottom: 20px;
		padding: 20px;
		/*box-shadow: 0 0 10px grey;
		background-color: white;*/
	}

	h1 {
		font-size: 24pt;
		margin-top: 30px;
	}

	input {
		margin-bottom: 10px;
	}

	.forgot-password {
		margin-top: 20px;
		margin-bottom: -10px;
	}

	.background {
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		/*background-color: #404040;*/
		display: flex;
		align-items: center;
	}

	@media (max-width: 400px) {
		form.login-form {
			box-shadow: none;
			padding: 10px;
		}
	}
</style>
